<div class="headerFlexW pr-4 m-3">
    <div class="content-block">
        <p class="bread-crumbs">Dispersiones / Nueva</p>
        <h2 class="">Dispersiones / Nueva</h2>
    </div>
</div>
<div class="content-block">
    <div class="dx-card responsive-paddings">
        <!-- TOP WRAPER  -->
        <div class=" flex flex-no-wrap flex-space-between mb-3">
            <!-- IXQ  -->
            <div class="w-30">
                <h3>Detalle de dispersión</h3>
                <div class="round-border-2 dispersionDetailsView">
                    <div class="icon-cyrcle">
                        <i class="fad fa-envelope-open-dollar fa-4x brand-color"></i>
                    </div>
                    <div class="mt-2">
                        <ul>
                            <li><span>Programa: </span> {{newDispersion.programName}}</li>
                            <li><span>Tipo: </span> {{newDispersion.dispersionTypeName}}</li>
                            <li *ngIf="newDispersion.dispersionTypeId >= 2"><span>Fecha: </span>
                                {{tempDateScheduled|date}}</li>
                            <li *ngIf="newDispersion.dispersionTypeId == 3"><span>Recurrencia: </span>
                                {{newDispersion.recurrance.name}}</li>
                            <!-- <li><span>Total a dispersar:</span> {{newDispersion.dispersionAmount|currency}}</li>
                            <li><span>Total de dispersiones:</span> {{amountOfDispersions}}</li> -->
                        </ul>
                    </div>
                </div>
            </div>
            <!-- DER  -->
            <div class="w-70">
                <h3>Parámetros de dispersión</h3>
                <div class="round-border-2">

                    <div class='dx-field'>
                        <div class='dx-field-label' *ngIf="visible_list_companies">Empresa</div>
                        <div class='dx-field-value'>
                            <dx-select-box [visible]="visible_list_companies" [dataSource]="companies"
                                displayExpr="companyName" valueExpr="id" (onValueChanged)="checkCompany($event.value)">
                                <dx-validator>
                                    <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                                </dx-validator>
                            </dx-select-box>
                        </div>
                    </div>

                    <div class='dx-field'>
                        <div class='dx-field-label'>Programa</div>
                        <div class='dx-field-value'>
                            <dx-select-box [(value)]="newDispersion.programId" [dataSource]="programs"
                                displayExpr="programName" valueExpr="programId" (onValueChanged)="checkProgram($event.value)">
                                <dx-validator>
                                    <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                                </dx-validator>
                            </dx-select-box>
                        </div>
                    </div>
                    <div class='dx-field'>
                        <div class='dx-field-label'>Tipo de dispersión</div>
                        <div class='dx-field-value'>
                            <dx-select-box [(value)]="newDispersion.dispersionTypeId" [dataSource]="dispersionTypeIds"
                                displayExpr="name" valueExpr="id" (onValueChanged)="checkType()">
                                <dx-validator>
                                    <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                                </dx-validator>
                            </dx-select-box>
                        </div>
                    </div>

                    <div class='dx-field' *ngIf="this.newDispersion.dispersionTypeId >= 2">
                        <div class='dx-field-label'>Fecha de dispersión</div>
                        <div class='dx-field-value'>
                            <dx-date-box displayFormat="shortdate" type="date" [(value)]="tempDateScheduled"
                                [min]="minDate">
                                <dx-validator>
                                    <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                                </dx-validator>
                            </dx-date-box>
                        </div>
                    </div>

                    <div class='dx-field' *ngIf="this.newDispersion.dispersionTypeId == 3">
                        <div class='dx-field-label'>Recurrencia</div>
                        <div class='dx-field-value'>
                            <dx-select-box [(value)]="newDispersion.recurrance.id" [dataSource]="dispersionRepeat"
                                displayExpr="name" valueExpr="id" (onValueChanged)="checkRecurrance($event.value)">
                                <dx-validator>
                                    <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                                </dx-validator>
                            </dx-select-box>
                        </div>
                    </div>
                    <div class=" pt-3 pb-3">
                        <dx-button id="button" [useSubmitBehavior]="true" type="default"
                            (onClick)="getBeneficiaries($event)" text="Seleccionar Beneficiarios" class="float-right"
                            *ngIf="this.newDispersion.programId &&
                    this.newDispersion.dispersionTypeId">
                        </dx-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- EMPLOYEES DATAGRID  -->
        <div class="mt-5">
            <h3>Beneficiarios de dispersión</h3>
            <dx-data-grid [dataSource]="tempBeneficiaries" keyExpr="employeeId" [showBorders]="true"
                (onSaving)="onSaving($event)">
                <dxo-load-panel [enabled]="true"></dxo-load-panel>
                <dxo-editing mode="batch" [allowUpdating]="true" [selectTextOnEditStart]="true" startEditAction="click">
                </dxo-editing>
                <dxo-selection mode="multiple"></dxo-selection>
                <dxi-column dataField="employeeId" caption="id" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="cardParsed" caption="Tarjeta"></dxi-column>
                <dxi-column dataField="employeeName" caption="Nombre" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="middleName" caption="Segundo nombre" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="employeeLastName" caption="Apellido paterno" [allowEditing]="false">
                </dxi-column>
                <dxi-column dataField="employeeSecondLastName" caption="Apellido materno" [allowEditing]="false">
                </dxi-column>
                <dxi-column dataField="amount" caption="Monto a dispersar" dataType="number" format="currency">
                    <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
                    <dxi-validation-rule type="range" min="0" message="Error"></dxi-validation-rule>
                </dxi-column>
                <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                <ng-container *ngIf="false">
                    <dxo-summary>
                        <dxi-total-item column="employeeId" summaryType="count">
                        </dxi-total-item>
                        <!-- <dxi-total-item column="amount" summaryType="sum" valueFormat="currency">
                        </dxi-total-item> -->
                    </dxo-summary>
                </ng-container>
            </dx-data-grid>
        </div>
        <div class="responsive-paddings" *ngIf="enable_upload_users_excel_dispersion">
            <form id="form_csv" [formGroup]="uploadForm" enctype="multipart/form-data">
              <div class="upload-container round-border">
                <h3>Subir excel de usuarios a dispersar</h3>
                <div class="uploaddContent">
                  <div class=" mt-3">
                    <div class="flex felx-nowrap flex-space-between mt-4">
                        <input type="file" name="xlsxreport" id="xlsxreport" (change)="fileupload($event)"><br>
                    </div>
                    <br />
                    <div>
                        <dx-button id="button" type="default" (onClick)="confirmDispersion()" text="Confirmar Dispersión"
                            class="txt-center">
                        </dx-button>
                    </div>
                    <!--<input type="file" name="csvreport" id="csvreport" (change)="fileupload($event)"><br>
                    <dx-button text="Subir Archivo" icon="plus" type="default" (onClick)="onSubmitFileCsv()" class="mt-2">
                    </dx-button>-->
                  </div>
                </div>
              </div>
            </form>
          </div>
    </div>
</div>
<dx-popup [width]="600" [height]="450" [showTitle]="true" title="Resumen de dispersión" [dragEnabled]="false"
    [closeOnOutsideClick]="true" [(visible)]="popupVisible">
    <div *dxTemplate="let data of 'content'" class="confirmation-popup">
        <div class="divTable mt-3">
            <div class="divTableBody">
                <div class="divTableRow">
                    <div class="divTableCell">Programa: {{newDispersion.programName}}</div>
                    <div class="divTableCell">Total a dispersar: {{newDispersion.dispersionAmount|currency}}</div>
                </div>
                <div class="divTableRow tbl-bkg">
                    <div class="divTableCell">Tipo: {{newDispersion.dispersionTypeName}}</div>
                    <div class="divTableCell">Comisiones: {{newDispersion.fees|currency}}</div>
                </div>
                <div class="divTableRow">
                    <div class="divTableCell">Total de dispersiones: {{amountOfDispersions}}</div>
                    <div class="divTableCell">IVA: {{newDispersion.tax|currency}}</div>
                </div>
                <div class="divTableRow  tbl-bkg">
                    <div class="divTableCell">
                        <span *ngIf="newDispersion.dispersionTypeId >= 2">Fecha:
                            {{newDispersion.dateScheduled|date}}</span>
                    </div>
                    <div class="divTableCell">Total a facturar: {{newDispersion.granTotal|currency}}</div>
                </div>
                <div class="divTableRow">
                    <div class="divTableCell">
                        <span *ngIf="newDispersion.dispersionTypeId == 3">Recurrencia:
                            {{newDispersion.recurrance.name}}</span>
                    </div>
                    <div class="divTableCell"></div>
                </div>
            </div>
        </div>
        <div class="flex felx-nowrap flex-space-between mt-4">
            <dx-button id="cancelBtn" type="warning" (onClick)="cancelDispersion()" text="Cancelar" class="txt-center">
            </dx-button>
            <dx-button id="button" type="default" (onClick)="executeDispersion()" text="Confirmar Dispersión"
                class="txt-center">
            </dx-button>
        </div>
    </div>
</dx-popup>